import React, { Component } from "react"
import { Row, Col } from "antd"
import cookie from "react-cookies"
import { connect } from "react-redux"
import { Button as MuiButton } from '@mui/material';
import { aclPermissions, hasPermissions } from "const/ACLPermissions"
import {isSuperuser} from "../../../utils/utils";

class CollectiveActionBar extends Component {
    constructor(props) {
        super(props)

        this.is_superuser = isSuperuser()
    }

    disabled = () =>
        !(this.props?.selectedUserIds && this.props?.selectedUserIds?.length > 0)

    getUsernamesFromIds = () =>
        this.props?.selectedUserIds.map(id => this.props.allUsers?.[id]?.username)

    render () {
        return (
            <div>
                <Row type="flex" gutter="8" justifyContent="center" style={{ paddingLeft: "5px" }}>
                    {!this.disabled() ?
                        <Col style={{ paddingTop: "5px" }}>
                            <span>
                                What do you want to do with the selected users?
                            </span>
                        </Col> :
                        <></>
                    }
                    <Col>
                        <div>
                            <MuiButton
                                type="danger"
                                color="secondary"
                                size="small"
                                variant="outlined"
                                disabled={this.disabled() || !hasPermissions([aclPermissions.delete_user])}
                                onClick={this.props.openDeleteUserModal}
                                style={{ visibility: this.disabled() ? "hidden" : "visible" }}
                            >
                                {"Delete User(s)"}
                            </MuiButton>
                        </div>
                    </Col>
                    {/*disabled for superuser until api is fixed to accomodate cross org policy assignment*/}
                    <Col>
                        <div>
                            <MuiButton
                                type="primary"
                                color="primary"
                                size="small"
                                variant="outlined"
                                disabled={this.disabled() || !hasPermissions([aclPermissions.update_user]) || this.is_superuser}
                                onClick={this.props.openChangePolicyModal}
                                style={{ visibility: this.disabled() ? "hidden" : "visible" }}
                            >
                                {"Change User(s) Policy"}
                            </MuiButton>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <MuiButton
                                type="primary"
                                color="primary"
                                size="small"
                                variant="outlined"
                                disabled={this.disabled() || !hasPermissions([aclPermissions.update_user])}
                                onClick={() => this.props.openChangeGroupModal({ selectedGroupAction: "add" })}
                                style={{ visibility: this.disabled() ? "hidden" : "visible" }}
                            >
                                {"Add Group"}
                            </MuiButton>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    allGroups: Object.values(state.searchUserReducer.groups || {}),
})

export default connect(mapStateToProps)(CollectiveActionBar)